import { render, staticRenderFns } from "./red-packet-rolling.vue?vue&type=template&id=68bae6ce&scoped=true&"
import script from "./red-packet-rolling.vue?vue&type=script&lang=js&"
export * from "./red-packet-rolling.vue?vue&type=script&lang=js&"
import style0 from "./red-packet-rolling.vue?vue&type=style&index=0&id=68bae6ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bae6ce",
  null
  
)

export default component.exports